import { render } from "./GrapesJS.vue?vue&type=template&id=3b887784&bindings={\"editor\":\"data\",\"value\":\"data\",\"assets\":\"options\"}"
import script from "./GrapesJS.vue?vue&type=script&lang=js"
export * from "./GrapesJS.vue?vue&type=script&lang=js"

import "./GrapesJS.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script